import { render, staticRenderFns } from "./Orchestration-Status.vue?vue&type=template&id=bc82db32&lang=pug"
import script from "./Orchestration-Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Orchestration-Status.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports